import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { PaleState, ThunkDispatchFunc } from '@/interfaces';

import displayValues from '@/resources/displayValues.json';

import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';

import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

export const MealFilter = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.meals);
    const checkboxValues = useSelector((s: PaleState) => s.filters.meals);

    const mealsDisplay = displayValues?.amenities?.meals ?? {};

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxMeal(valueOrMap));
    };

    const fetchResultsProxy: CheckboxDispatchProps['fetchResults'] = (queryParams) => {
        dispatch(fetchResults(queryParams));
    };

    const hasOptions = useMemo(
        () => Array.isArray(facetList) && facetList.some((f) => Boolean(mealsDisplay[f.value])),
        [facetList, mealsDisplay],
    );

    return hasOptions ? (
        <CheckboxFilter
            id="mealFilter"
            label="Måltider"
            facetList={facetList}
            displayValues={mealsDisplay}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={fetchResultsProxy}
        />
    ) : null;
};
